<template>
  <div
    class="d-flex flex-column align-center justify-center"
    style="min-height: calc(50vh)"
  >
    <v-card
      outlined
      class="pa-6 d-flex flex-column justify-center align-center"
      max-width="400"
      width="100%"
      rounded="xl"
    >
      <h5 class="mb-6">Idenficação do cliente</h5>

      <template v-if="!success">
        <v-avatar size="70" class="mb-4">
          <v-icon size="70">mdi-account-circle</v-icon>
        </v-avatar>
        <phone-input
          ref="phoneInput"
          :phone="whatsapp"
          @update:phone="(e) => (whatsapp = e)"
          :ddi="ddi"
          @update:ddi="(e) => (ddi = e)"
          @valid="(v) => (valid = v)"
          dense
          outlined
          autofocus
          label="WhatsApp do Destinatário"
          :disabled="loading"
        />

        <v-alert v-if="error" type="error" dense class="ma-0 w-full">
          {{ error }}
        </v-alert>
      </template>
      <template v-else>
        <v-avatar v-if="!userData" size="70" class="mb-4">
          <v-icon large>mdi-account-off</v-icon>
        </v-avatar>
        <base-avatar
          v-else
          size="70"
          :src="userData?.photo || null"
          :seed="userData?.id"
        />
        <h4 class="mt-2 mb-0">{{ userData?.name || "Conta não criada" }}</h4>
        <p>{{ whatsapp }}</p>

        <v-alert v-if="error" type="error" dense class="ma-0 mb-2 w-full">
          {{ error }}
        </v-alert>
        <v-btn
          block
          large
          depressed
          color="primary"
          class="mb-2"
          @click="selectClient"
          :loading="loading"
          ref="confirmButton"
        >
          Continuar
        </v-btn>
        <v-btn block text @click="changeClient" :disabled="loading">
          Alterar cliente
        </v-btn>
      </template>
    </v-card>
  </div>
</template>
<script>
import VIRTUAL_POS from "@/services/staff/virtualPos";
import PhoneInput from "../../global/PhoneInput.vue";

export default {
  name: "ClientIdentification",
  components: {
    PhoneInput,
  },
  props: {
    token: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    cart: {
      type: Object,
      required: true,
    },
    selectedParty: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      whatsapp: "",
      ddi: 55,
      valid: false,
      loading: false,
      error: null,
      userData: null,
      success: false,
    };
  },
  methods: {
    changeClient() {
      this.whatsapp = "";
      this.ddi = 55;
      this.valid = false;
      this.loading = false;
      this.success = false;
      this.userData = null;
      this.error = null;
      this.$nextTick(() => {
        this.$refs.phoneInput.focus();
      });
    },
    async selectClient() {
      try {
        this.error = null;
        this.loading = true;
        var response;
        if (this.cart._kit) {
          response = await VIRTUAL_POS.sellKit(
            this.token,
            this.selectedParty.id,
            {
              kitId: this.cart._kit.kit.id,
              amount: this.cart._kit.kit.price,
              user: {
                phone: this.whatsapp,
                ddi: this.ddi,
              },
            }
          );
        } else {
          response = await VIRTUAL_POS.sell(this.token, this.selectedParty.id, {
            ...this.parsedCart,
            user: {
              phone: this.whatsapp,
              ddi: this.ddi,
            },
          });
        }

        this.$emit("update:payment", response.payment);
        this.$emit("update:client", {
          identifier: {
            phone: this.whatsapp,
            ddi: this.ddi,
          },
          user: this.userData,
        });
        this.$emit("next");
      } catch (error) {
        this.error = error.message || "Erro ao selecionar cliente.";
      } finally {
        this.loading = false;
      }
    },
    async fetchUserData() {
      this.loading = true;
      this.error = null;
      try {
        const response = await VIRTUAL_POS.searchUser(
          this.token,
          this.selectedParty.id,
          {
            phone: this.whatsapp,
            ddi: this.ddi,
          }
        );
        this.userData = response.user;
        this.success = true;
        this.$nextTick(() => {
          console.log(this.$refs.confirmButton);
        });
        // Fetch user data logic here
      } catch (error) {
        this.error = error.message || "Erro ao buscar usuário.";
        this.$refs.phoneInput.focus();
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    parsedCart() {
      var amount = 0;
      const order = {};
      Object.entries(this.cart).forEach(([key, item]) => {
        if (item.quantity <= 0) return;
        order[key] = { quantity: item.quantity };
        amount += item.quantity * item.ticketBlock.price;
      });
      return { amount, cart: order };
    },
  },
  watch: {
    valid(newVal) {
      this.error = null;
      this.success = false;
      if (newVal) this.fetchUserData();
      else this.userData = null;
    },
  },
};
</script>
